import { render, staticRenderFns } from "./TermsGeneratorForm.vue?vue&type=template&id=0db72b7f"
import script from "./TermsGeneratorForm.vue?vue&type=script&lang=js"
export * from "./TermsGeneratorForm.vue?vue&type=script&lang=js"
import style0 from "./TermsGeneratorForm.vue?vue&type=style&index=0&id=0db72b7f&prod&module=%24s&lang=scss"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports